import styled from "styled-components";
import Box from "ui-box";

export default styled(Box)`
  display: flex;
`;
